import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SvgIcon from '../../SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0v15V0zm15 15V0v15zm-3.96-7.737L7.737 3.96 1.2 10.497V13.8h3.303l6.537-6.537zM6.2 13.8h6.3c.276 0 .5.224.5.5v.2c0 .276-.224.5-.5.5H1c-.552 0-1-.448-1-1v-3.586c0-.265.105-.519.293-.707l7.091-7.091c.195-.195.512-.195.707 0l4.293 4.293c.195.195.195.512 0 .707L6.2 13.8zm7.739-7.739l-.141.141c-.195.195-.512.195-.707 0L8.798 1.909c-.195-.195-.195-.512 0-.707l.141-.141c.196-.196.512-.196.707 0l4.293 4.293c.196.195.196.511 0 .707z",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 20V0v20zM20 0v20V0zm-2.5 17h-7.379l1.5-1.5H17.5c.276 0 .5.224.5.5v.5c0 .276-.224.5-.5.5zM9.621 5.5L11 4.121 14.879 8 13.5 9.379 9.621 5.5zm-2.242 10H3.5v-3.879l5.061-5.06 3.878 3.878-5.06 5.061zm2.914-12.793l-8 8c-.188.188-.293.442-.293.707V16c0 .552.448 1 1 1h4.586c.265 0 .519-.105.707-.293l8-8c.39-.39.39-1.024 0-1.414l-4.586-4.586c-.39-.39-1.024-.39-1.414 0z",
  fillRule: "evenodd"
});

export default function EditIcon(props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}
EditIcon.displayName = 'EditIcon';